import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertCircle, LogOut } from 'lucide-react';
import { supabase } from '../../lib/supabase';

const JWTExpirationHandler = ({ children }) => {
  const navigate = useNavigate();
  const [showExpirationModal, setShowExpirationModal] = useState(false);

  useEffect(() => {
    // Listen for auth state changes (including JWT expiration)
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      if (event === 'TOKEN_REFRESHED' && !session) {
        // Token refresh failed - session expired
        setShowExpirationModal(true);
      }
      
      if (event === 'SIGNED_OUT') {
        // User has been signed out
        setShowExpirationModal(true);
      }
    });

    // Set up error listener for 401/403 responses
    // const handleAuthError = (error) => {
    //   if (error.status === 401 || error.message.includes('JWT')) {
    //     setShowExpirationModal(true);
    //   }
    // };

    // Listen for JWT expiration errors
    // const unsubscribe = supabase.auth.onAuthStateChange((event, session) => {
    //   if (!session && event === 'SIGNED_OUT') {
    //     setShowExpirationModal(true);
    //   }
    // });

    // Check if the current session is expired on mount
    supabase.auth.getSession().then(({ data: { session }, error }) => {
      if (!session || error) {
        setShowExpirationModal(true);
      }
    });

    return () => {
      subscription.unsubscribe();
    };
  }, []);

  const handleLogout = async () => {
    try {
      await supabase.auth.signOut();
      localStorage.removeItem('session');
      navigate('/admin/login');
    } catch (error) {
      console.error('Logout error:', error);
      navigate('/admin/login');
    }
  };

  return (
    <>
      {children}
      {showExpirationModal && (
        <div className="fixed inset-0 z-50 overflow-y-auto">
          <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center">
            {/* Backdrop */}
            <div className="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75" />
            
            {/* Modal */}
            <div className="relative inline-block overflow-hidden text-left align-bottom transition-all transform bg-white rounded-lg shadow-xl sm:my-8 sm:align-middle sm:max-w-md sm:w-full">
              <div className="px-4 pt-5 pb-4 bg-white sm:p-6 sm:pb-4">
                <div className="sm:flex sm:items-start">
                  <div className="flex items-center justify-center flex-shrink-0 w-12 h-12 mx-auto bg-red-100 rounded-full sm:mx-0 sm:h-10 sm:w-10">
                    <AlertCircle className="w-6 h-6 text-red-600" />
                  </div>
                  <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                    <h3 className="text-lg font-medium leading-6 text-gray-900">
                      Session Expired
                    </h3>
                    <div className="mt-2">
                      <p className="text-sm text-gray-500">
                        Your session has expired for security reasons. Please log in again to continue working.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="px-4 py-3 bg-gray-50 sm:px-6 sm:flex sm:flex-row-reverse">
                <button
                  type="button"
                  onClick={handleLogout}
                  className="inline-flex justify-center w-full px-4 py-2 text-base font-medium text-white bg-teal-600 border border-transparent rounded-md shadow-sm hover:bg-teal-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500 sm:ml-3 sm:w-auto sm:text-sm"
                >
                  <LogOut className="w-4 h-4 mr-2" />
                  Log in again
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default JWTExpirationHandler;